<!-- Body -->
<div class="dialog-body">

    <!-- Close Button -->
    <button
        mat-icon-button
        mat-dialog-close
        class="close-btn"
        aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>

    <!-- Show Cards -->
    <div class="cards-container" *ngIf="showNoRecordFound==false">

        <div class="doc-card" *ngFor="let item of aiRunningList">

            <!-- PDF Icon -->
            <div class="pdf-icon">
                <app-doc-icons [iconType]="'PDF'"></app-doc-icons>
            </div>

            <!-- Title -->
            <div class="card-title">
                {{ item.placeholderName }}
            </div>

            <!-- Footer -->
            <div class="card-footer">
                <!-- Your buttons -->
            </div>

        </div>

    </div>

    <!-- No Records -->
    
        <div class="no-records" *ngIf="showNoRecordFound==true">
            <mat-icon>folder_off</mat-icon>
            <p>No AI processes are currently running.</p>
        </div>
   

</div>